// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"4804686f","95":"3783770f","274":"f2eae980","419":"63ef2a0a","476":"6fbac793","774":"6e7b09c4","858":"fd3f6f43"}[chunkId] + ".chunk.js";
};